var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.668,
    height: 15.668,
    viewBox: "0 0 15.668 15.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M18.611,18.3h0V12.551c0-2.811-.605-4.977-3.892-4.977a3.412,3.412,0,0,0-3.073,1.689h-.046V7.836H8.489V18.3h3.245v-5.18c0-1.364.259-2.683,1.947-2.683,1.664,0,1.689,1.556,1.689,2.77V18.3Z",
    transform: "translate(-2.947 -2.629)",
    fill: "#e4002f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M.4,7.977H3.645v10.46H.4Z",
    transform: "translate(-0.137 -2.769)",
    fill: "#e4002f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M1.881,0A1.89,1.89,0,1,0,3.763,1.881,1.882,1.882,0,0,0,1.881,0Z",
    transform: "translate(0 0)",
    fill: "#e4002f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0d582ab28ea0b9d79c3b2349aad651b3.svg";
export { ForwardRef as ReactComponent };